export default __webpack_public_path__ + "static/media/head03_ko_sp.42db6988.png";